import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { emptyFn } from '../shared/function/function.helpers';
import { ItemResponseWrapper } from '../shared/http.types';
import { IServerDateTime } from './server-time.types';
import { environment } from 'src/environments/environment';

@Injectable()
export class ServerTimeService {
  private serverTime$: BehaviorSubject<Date> = new BehaviorSubject(new Date());
  private initDateTime: number = Date.now();

  constructor(
    private http: HttpClient,
  ) {}

  public get serverTimeReady(): Promise<void> {
    return this.serverTime$.asObservable()
      .pipe(mapTo(void(0)))
      .toPromise();
  }

  public init = (): void => {
    this.http.get<ItemResponseWrapper<IServerDateTime>>(`${environment.backendBaseUrl}/auth/utils/current-date`)
      .subscribe(
        res => this.setServerTime(res.data.dateTime),
        emptyFn,
      );
  }

  public setServerTime(dateTime: string): void {
    if (this.serverTime$.isStopped) {
      return;
    }

    this.initDateTime = Date.now();
    this.serverTime$.next(new Date(dateTime));
    this.serverTime$.complete();
  }

  public currentDateTime(): Date {
    const currentDateTime = new Date();
    const serverTime = this.serverTime$.value;
    currentDateTime.setTime(serverTime.getTime() + Date.now() - this.initDateTime);

    return currentDateTime;
  }

  public now(): Date {
    return this.currentDateTime();
  }
}
